import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/image.svg
 */
const IconImage: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M24 6.309V17.69a4.12 4.12 0 01-4.118 4.135H4.118A4.152 4.152 0 010 17.69V6.31a4.152 4.152 0 014.118-4.134h15.764a4.116 4.116 0 013.809 2.553A4.12 4.12 0 0124 6.308zm-2.183 8.804V6.31a1.933 1.933 0 00-1.192-1.8 1.933 1.933 0 00-.743-.15H4.118a1.957 1.957 0 00-1.951 1.95v7.088l3.8-3.785a3.168 3.168 0 013.454-.688c.385.16.734.394 1.029.688l5.53 5.534a.998.998 0 00.7.287c.26-.005.509-.107.697-.287a3.113 3.113 0 012.242-.951 3.167 3.167 0 012.198.918zm-.06 3.016l-1.453-1.441a.97.97 0 00-1.385 0c-.596.59-1.4.924-2.239.93a3.167 3.167 0 01-2.243-.93l-5.53-5.534a.991.991 0 00-1.397 0l-5.343 5.343v1.194a1.96 1.96 0 001.95 1.952h15.765a1.9 1.9 0 001.862-1.514h.013z"
      fill="currentColor"
    />
    <path
      d="M16.677 5.959a3.004 3.004 0 012.955 3.591 3.006 3.006 0 01-5.955-.59 2.994 2.994 0 013-3.001zm.813 3a.816.816 0 10-1.631 0 .816.816 0 001.631 0z"
      fill="currentColor"
    />
  </svg>
);

export default IconImage;
